import { store } from "@/store.js";

// Helper function to get dynamic values at runtime instead of module load time
function getInstitutionId() {
  const school = store.state.userData?.school || null;
  return (
    school?._esis_organizationInfo?.INSTITUTION_ID ||
    school?._esis_schoolInfo?.legalEntityId ||
    null
  );
}

function getV2BaseUrl() {
  return store.state.domainESISAddressV2 || "https://hubv2.esis.edu.mn";
}

// Function to get endpoint URL with current store values
export function getEndpointUrl(endpointKey, params = {}) {
  const endpoint = endpoints[endpointKey];
  if (!endpoint) return null;

  const v2BaseUrl = getV2BaseUrl();
  const institutionId = params.legalEntityId
    ? params.legalEntityId
    : getInstitutionId();

  let url = endpoint.urlTemplate
    .replace("${v2BaseUrl}", v2BaseUrl)
    .replace("${institutionId}", institutionId);

  // Replace any path params
  if (endpoint.params) {
    for (const param of endpoint.params) {
      if (params[param]) {
        url = url.replace(`:${param}`, params[param]);
      }
    }
  }

  return url;
}

export const endpoints = {
  //Багшийн мэдээлэл
  "teacher/list": {
    index: 2,
    name: "Багшийн жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/teacher/list?institutionId=${institutionId}",
    method: "GET",
    v1Url: "https://hub.esis.edu.mn/svc/api/hub/teacher/list",
  },

  //Байгууллагын мэдээлэл
  "school/staff": {
    index: 8,
    name: "Байгууллагын ажилчдын жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/school/staff?institutionId=${institutionId}",
    method: "GET",
    v1Url: "",
  },
  "group/list": {
    index: 12,
    name: "Байгууллагын бүлгийн мэдээлэл",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/group/list?institutionId=${institutionId}",
    method: "GET",
    v1Url: "https://hub.esis.edu.mn/svc/api/hub/group/list",
  },
  "program/list": {
    index: 16,
    name: "Сургалтын хөтөлбөрийн жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/program/list?institutionId=${institutionId}",
    method: "GET",
    v1Url: "https://hub.esis.edu.mn/svc/api/hub/program/list",
  },
  "program/stage/list": {
    index: 17,
    name: "Сургалтын хөтөлбөр түвшингийн жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/program/stage/list/:programOfStudyId?institutionId=${institutionId}",
    params: ["programOfStudyId"],
    method: "GET",
    v1Url: "https://hub.esis.edu.mn/svc/api/hub/program/stage/list/:programId",
  },
  "program/stage/plan/list": {
    index: 18,
    name: "Сургалтын хөтөлбөрийн төлөвлөгөөний жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/program/stage/plan/list/:programOfStudyId/:programStageId?institutionId=${institutionId}",
    params: ["programOfStudyId", "programStageId"],
    method: "GET",
    v1Url:
      "https://hub.esis.edu.mn/svc/api/hub/program/stage/plan/list/:programId/:programStageId",
  },
  "program/stage/plan/course/list": {
    index: 19,
    name: "Сургалтын хөтөлбөрийн хичээлийн жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/program/stage/plan/course/list/:programOfStudyId/:programStageId/:programPlanId?institutionId=${institutionId}",
    params: ["programOfStudyId", "programStageId", "programPlanId"],
    method: "GET",
    v1Url:
      "https://hub.esis.edu.mn/svc/api/hub/program/stage/plan/course/list/:programId/:programStageId/:programPlanId",
  },
  "organization/info": {
    index: 39,
    name: "Байгууллагын ерөнхий мэдээлэл",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/organization/info?institutionId=${institutionId}",
    method: "GET",
    v1Url: "https://hub.esis.edu.mn/svc/api/hub/organization/info",
  },
  "building/list": {
    index: 40,
    name: "Байгууллагын барилга байгууламжын жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/building/list?institutionId=${institutionId}",
    method: "GET",
    v1Url: "https://hub.esis.edu.mn/svc/api/hub/building/list",
  },

  //Суралцагчийн мэдээлэл
  "student/list": {
    index: 27,
    name: "Бүлгийн суралцагчийн жагсаалт",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/group/student/list/:studentGroupId?institutionId=${institutionId}",
    params: ["studentGroupId"],
    method: "GET",
    v1Url:
      "https://hub.esis.edu.mn/svc/api/hub/group/student/list/:studentGroupId",
  },

  //Үнэлгээ
  "assessment2/list": {
    index: 38,
    name: "Цахим сургалтын үнэлгээ харах",
    urlTemplate:
      "${v2BaseUrl}/svc/api/hub/v2/assessment2/list/:academicYear/:studentGroupId?institutionId=${institutionId}",
    params: ["academicYear", "studentGroupId"],
    method: "GET",
    v1Url: "",
  },
};

function camelToUpperSnake(str) {
  return str.replace(/([A-Z])/g, "_$1").toUpperCase();
}

// Transform camelCase fields to UPPER_SNAKE_CASE
export function transformFields(teacher) {
  const transformed = {};
  for (const [key, value] of Object.entries(teacher)) {
    const newKey = camelToUpperSnake(key);
    transformed[newKey] = value;
  }
  return transformed;
}
